import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { sendSupportEmail } from '../redux/email/actions';
import * as emailStatus from '../redux/email/status';
import * as selectors from '../redux/selectors';

import FormGroup from '../components/FormGroup';
import Button from '../components/Button';

import close from '../assets/icons/ic-close-black.svg';
import Logo from '../assets/logos/logo';

import './MessageForm.css';

class MessageForm extends Component {
  static propTypes = {
    profile: PropTypes.shape({
      profileID: PropTypes.string,
      name: PropTypes.string,
      nric: PropTypes.string,
      email: PropTypes.string,
      mobile: PropTypes.string,
    }).isRequired,
    version: PropTypes.string,
    page: PropTypes.string,
    device: PropTypes.string,
    browser: PropTypes.string,
    close: PropTypes.bool,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    version: null,
    page: null,
    device: null,
    browser: null,
    close: false,
    onClick: null,
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static mapStateToProps = state => ({
    account: selectors.getAccount(state),
    profile: selectors.getProfile(state),
    location: state.router.location,
  })

  constructor(props) {
    super(props);
    this.state = {
      name: props.profile.name || '',
      email: props.profile.email || '',
      mobile: props.profile.mobile || '',
      textarea: '',
      subject: '',
      loading: false,
    };
  }

  componentWillReceiveProps(props) {
    this.setState({
      name: props.profile.name || '',
      email: props.profile.email || '',
      mobile: props.profile.mobile || '+60',
    });
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, () => {
        resolve();
      });
    });
  }

  submitable() {
    const {
      loading,
      name,
      email,
      mobile,
      message,
      textarea,
      subject,
    } = this.state;
    return (loading === false && subject !== '' && name !== '' && email !== '' && mobile !== '' && message !== '' && textarea !== '');
  }

handleOnClose = (event) => {
  event.preventDefault();
  if (this.props.onClick) {
    this.props.onClick(event);
  }
  this.setState({
    subject: '',
    message: null,
    textarea: '',
    supportForm: false,
  });
}

handleSend = async (event) => {
  event.preventDefault();
  this.clearMsgTimer();
  this.clearMessage();
  // const { store } = this.context;
  this.setStateAsync({
    loading: true,
  });
  await this.SupportEmail();
  // store.dispatch(flashMessage('Your request is on its way. Stay tuned.', 'notify'));
}

handleChange = (event) => {
  this.setState({
    [event.target.name]: event.target.value,
  });
}

clearMessage() {
  this.msgTimer = setTimeout(() => {
    this.setStateAsync({
      message: null,
    });
  }, 5000);
}

clearMsgTimer() {
  if (this.msgTimer) {
    clearTimeout(this.msgTimer);
  }
}

async SupportEmail() {
  const { store } = this.context;
  const {
    textarea,
    subject,
    name,
    email,
    mobile,
  } = this.state;
  const {
    profile,
    version,
    page,
    device,
    browser,
  } = this.props;
  const bodyProps = profile && profile.profileID ? {
    profileID: profile.profileID,
  } : {
    name,
    email,
    mobile,
    profileID: `${profile.profileID}`,
  };
  const body = {
    title: `[DSR-PG] ${subject}`,
    content: textarea,
    version,
    page,
    device,
    browser,
    ...bodyProps,
  };

  const res = await store.dispatch(sendSupportEmail(body));
  if (res === emailStatus.EMAIL_STATUS_OK) {
    this.setStateAsync({
      loading: false,
      supportForm: true,
    });
  }
  // TODO: HANDLE ERROR
  this.setStateAsync({
    loading: false,
    message: 'Oops, there is an error occured, please try again.',
  });
}

render() {
  const { profile } = this.props;
  return (
    <div>
      { this.props.close ?
        <div className="MessageForm">
          <div className="modal">
            { !this.state.supportForm ?
              <div>
                {
                  this.state.loading ?
                    <div className="loadingModal">
                      <Logo medium spin white />
                    </div>
                  : null
                }
                <div className="headerModal">
                  <h3>Need Help?</h3>
                  <button onClick={this.handleOnClose}>
                    <img className="close-icon" alt="close" src={close} />
                  </button>
                </div>
                <div className="line-separator" />
                <FormGroup sideLabel>
                  <label htmlFor="mhub-user-details-subject">Subject<span className="requiredAsterisk">*</span></label>
                  <input
                    name="subject"
                    value={this.state.subject}
                    onChange={this.handleChange}
                    placeholder="Subject"
                  />
                </FormGroup>
                <FormGroup sideLabel>
                  <label htmlFor="mhub-user-details-name">Name<span className="requiredAsterisk">*</span></label>
                  <input
                    name="name"
                    value={this.state.name}
                    onChange={this.handleChange}
                    placeholder="Name As Per MyKad"
                    disabled={profile && profile.name && profile.name.length > 0}
                  />
                </FormGroup>
                <FormGroup sideLabel>
                  <label htmlFor="mhub-user-details-mobile">Mobile<span className="requiredAsterisk">*</span></label>
                  <input
                    name="mobile"
                    value={this.state.mobile}
                    onChange={this.handleChange}
                    placeholder="Mobile Number"
                    disabled={profile && profile.mobile && profile.mobile.length > 3}
                  />
                </FormGroup>
                <FormGroup sideLabel>
                  <label htmlFor="mhub-user-details-email">Email<span className="requiredAsterisk">*</span></label>
                  <input
                    name="email"
                    value={this.state.email}
                    onChange={this.handleChange}
                    placeholder="Email"
                    disabled={profile && profile.email}
                  />
                </FormGroup>
                <FormGroup sideLabel>
                  <label htmlFor="mhub-user-details-message">Message<span className="requiredAsterisk">*</span></label>
                  <textarea
                    name="textarea"
                    value={this.state.textarea}
                    onChange={this.handleChange}
                    placeholder="Type your issue here..."
                  />
                </FormGroup>
                <div className="buttons">
                  <Button onClick={this.handleSend} disabled={!this.submitable()}>
                    Send
                  </Button>
                </div>
                <p className="messageHelper">{this.state.message}</p>
                <div className="line-separator" />
                <div className="details">
                  <p>Vesion: v{this.props.version}</p>
                  <p>Page: {this.props.page}</p>
                  <p>Device: {this.props.device}</p>
                  <p>Browser: {this.props.browser}</p>
                </div>
              </div>
            :
              <div className="loadDoneModal">
                <div className="headerModal notLoading">
                  <button onClick={this.handleOnClose}>
                    <img className="close-icon" alt="close" src={close} />
                  </button>
                </div>
                <div className="modalThanks">
                  <h3>Thank You</h3>
                  <p>We will review and contact you soon.</p>
                  <div className="buttons">
                    <Button onClick={this.handleOnClose}>Done</Button>
                  </div>
                </div>
              </div>
          }
          </div>
        </div>
        : null
      }
    </div>
  );
}
}

export default connect(MessageForm.mapStateToProps)(MessageForm);



// WEBPACK FOOTER //
// ./src/components/MessageForm.jsx